<script>
/* eslint-disable vue/require-default-prop */
export default {
  name: 'MsBaseComponent',
  props: {
    /**
     * rule dùng để validate control
     * {
     *  name: '',
     * compareValue: '',
     * customValidate: ''
     * }
     */
    rules: {
      type: Array,
      default: () => [],
    },
    /**
     * Tên của control phục vụ việc hiện thị message cho validate
     * Created by LTDAT(22.06.2020)
     */
    name: {
      default: null,
      type: String,
    },
    /**
     * thuộc tính readOnly cho các form sử dụng có thể khai báo trực tiếp
     */
    readOnly: {
      type: Boolean,
      default: false,
    },
    /**
     * Thuộc tính disable control (bổ sung lên đây để dùng chung cho toàn bộ các component)
     */
    disabled: {
      type: Boolean,
      default: false,
    },
    /**
     * label control - có thể k gán mà chỉnh ở ngoài cho link động
     */
    label: {
      default: null,
      type: String,
    },
    /** Có phải là được sử dụng trong grid edtor không */
    isGridEditor: {
      default: false,
      type: Boolean,
    },
    // eslint-disable-next-line vue/require-prop-types
    /** Thông tin lỗi */
    errorProvider: {
      type: Object,
      default: () => {
        return {}
      },
    },
    /**
     * Có show error message khi có lỗi không
     */
    isShowErrorMessage: {
      type: Boolean,
      default: true,
    },
  },
}
</script>
